import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UserSearchResult {
  id: string;
  full_name: string;
  avatar_url: string | null;
  is_verified: boolean;
  role: string;
}

export const useUserSearch = (query: string) => {
  const [users, setUsers] = useState<UserSearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!query.trim()) {
      setUsers([]);
      return;
    }

    const searchUsers = async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('id, full_name, avatar_url, is_verified, role')
          .ilike('full_name', `%${query}%`)
          .limit(10);

        if (error) throw error;
        setUsers(data || []);
      } catch (error) {
        console.error('Error searching users:', error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    const debounceTimer = setTimeout(searchUsers, 300);
    return () => clearTimeout(debounceTimer);
  }, [query]);

  return { users, loading };
};